import Component from "../component/component";
export default class HelloBar extends Component {
    constructor($element) {
        super($element);
        this.adjustPosition = this.adjustPosition.bind(this);
        this.onCloseClick = this.onCloseClick.bind(this);
        this.$closeButton = this.$component.find(".c-hello-bar_close");
        this.contentId = this.$component.attr("content-id");
        if (window.sessionStorage &&
            window.sessionStorage.getItem("helloBarClosed") !== this.contentId) {
            this.$component.fadeIn().css("display", "flex");
        }
        this.$closeButton.click(this.onCloseClick);
        this.adjustPosition();
    }
    adjustPosition() {
        const isWhiteLogoVis = $(".c-top-nav_logo-img--white").is(":visible");
        this.$component.toggleClass("c-hello-bar--low", isWhiteLogoVis);
    }
    onCloseClick() {
        if (window.sessionStorage) {
            sessionStorage.setItem("helloBarClosed", this.contentId);
        }
        this.$component.fadeOut({
            complete: () => {
                this.emit("closed");
            },
        });
    }
    static init() {
        const $helloBarBlock = $(".c-hello-bar");
        if ($helloBarBlock.length) {
            const helloBar = new HelloBar($helloBarBlock);
            return helloBar;
        }
        else {
            return null;
        }
    }
}
